import PropTypes from 'prop-types';
import { forwardRef, useState } from 'react';
// material
import { Avatar, useTheme } from '@material-ui/core';

// ----------------------------------------------------------------------

// eslint-disable-next-line react/prop-types
const MAvatar = forwardRef(({ color = 'default', sx, candidate, children, ...other }, ref) => {
  const theme = useTheme();
  // eslint-disable-next-line react/prop-types
  const [image, setImage] = useState(candidate?.user?.photoUrl);

  if (color === 'default') {
    return (
      <Avatar
        ref={ref}
        sx={sx}
        imgProps={{
          onError: () => {
            setImage(null);
          }
        }}
        {...other}
        {...(image && { src: image })}
      >
        {children}
      </Avatar>
    );
  }

  return (
    <Avatar
      ref={ref}
      sx={{
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        ...sx
      }}
      imgProps={{
        onError: () => {
          setImage(null);
        }
      }}
      {...other}
      {...(image && { src: image })}
    >
      {children}
    </Avatar>
  );
});

MAvatar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  src: PropTypes.string,
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error'])
};

export default MAvatar;
